import * as React from 'react'
import Helmet from 'react-helmet'

export const IE = () => (
  <Helmet>
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
  </Helmet>
)
